import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useState } from "vuex-composition-helpers";
import { computed, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";
import { NumberParser } from "@util/numberParse";
import { RootState } from "@medapro-types/common/rootstate";

type ViewModel = { localModel: string | null; disabled: boolean };

export default /*#__PURE__*/_defineComponent({
  __name: 'NumberRule',
  props: {
    value: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { userSettings } = useState<RootState>(["userSettings"]);
const { n: $n, t: $t } = useI18n();

//#region General


//#endregion

//#region ViewModel
const parser = new NumberParser(userSettings.value.CurrentLocale);
const initValueHelper = parseFloat(props.value);
const vm = reactive<ViewModel>({ localModel: isNaN(initValueHelper) ? null : $n(initValueHelper), disabled: false });
//#endregion

//#region Update vModel
watch(
  () => vm.localModel,
  (nv) => {
    emits("input", `${parser.parseLocaleStringToIndepentendNumberString(nv) ?? ""}`);
  },
  { immediate: true }
);
//#endregion

//#region Validation
const validationFeedback: Record<string, any> = computed(() => {
  const result = Number(parser.parseLocaleStringToIndepentendNumberString(vm.localModel));
  return typeof result === "number" && Number.isFinite(result) ? "" : $t("ValueIsNotNumber");
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_input = _resolveComponent("b-input")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createBlock(_component_b_input, {
    type: "text",
    "data-cy": "rule-number",
    modelValue: vm.localModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.localModel) = $event)),
    pattern: "[/^\\d*\\.?\\d*$/]",
    inputmode: "decimal",
    autocomplete: "off",
    lang: "de-DE",
    class: _normalizeClass({ 'border-danger': validationFeedback.value }),
    disabled: vm.disabled
  }, null, 8, ["modelValue", "class", "disabled"])), [
    [_directive_tooltip, validationFeedback.value]
  ])
}
}

})